import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as clientTypesApi from '../api/client_types';
import { translate } from '../i18n_text';
import { reactListTablesEnabled } from '../permissions';
import { session } from '../session';
import { GridView } from '../utils/grid_view';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { NamesListPage, NamesListProps, NamesListQuery, NamesListRow } from 'react-islands';

let template = require('raw-loader!../../templates/client_types.html').default;

class ClientTypesScreen implements ListLoaderDelegate<clientTypesApi.ClientTypeData> {
  listActions: ListHeaderAction[] = [
    { title: i18n.t('Add')(), icon: 'add_circle', href: '/client_types/new/' },
  ];

  newClientTypesTable = reactListTablesEnabled();

  private view = new GridView('client-types');

  tableProps = ko.pureComputed<NamesListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
    exportFileName: 'client-types',
  }));

  constructor(params: { filters: unknown }) {
    if (this.newClientTypesTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return clientTypesApi.list(params);
  }

  private fetchPage = (query: NamesListQuery): Promise<NamesListPage> =>
    this.view.fetchListPage(query, clientTypesApi.list, 'name_prefix', this);

  toRow = (data: clientTypesApi.ClientTypeData): NamesListRow => ({
    id: data.id || '',
    name: translate(data.name_json),
    url: session.toTenantPath(this.getEditUrl(data)),
    actions: delegateActions(this, data, this.view.reload),
  });

  instantiate(data: clientTypesApi.ClientTypeData) {
    return data;
  }

  getEditUrl(data: clientTypesApi.ClientTypeData) {
    return `/client_types/${data.id}/`;
  }

  remove(id: string) {
    return clientTypesApi.remove(id);
  }

  canRemove(entity: clientTypesApi.ClientTypeData) {
    return true;
  }
}

export let clientTypes = {
  name: 'client-types',
  viewModel: ClientTypesScreen,
  template: template,
};

ko.components.register(clientTypes.name, clientTypes);
